import format from "date-fns/format";
import { getUnixTimestamp } from "./unix-timestamp";

export const getFirstDayOfMonth = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth();

  return new Date(year, month, 1);
};

export const subtractYearsToDate = (date: Date, subtractYear: number) => {
  return new Date(
    date.getFullYear() - subtractYear,
    date.getMonth(),
    date.getDate(),
  );
};

export const addMothsToDate = (date: Date, addMonth: number) => {
  return new Date(
    date.getFullYear(),
    date.getMonth() + addMonth,
    date.getDate(),
  );
};

export const addMinutesToDate = (date: Date, minutes: number) => {
  const hrs = Math.floor((minutes || 0) / 3600);
  const min = ((minutes || 0) % 3600) / 60;

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours() + hrs,
    date.getMinutes() + min,
  );
};

export const getDateGoogleCalendarFormat = (unix: number, timeZone: string): string => {
  const dateTemp = new Date(unix * 1000).toLocaleString("en-US", { timeZone: timeZone || undefined });
  const date = new Date(dateTemp);

  return [
    date.getFullYear(),
    ("0" + (date.getMonth() + 1)).slice(-2),
    ("0" + date.getDate()).slice(-2),
    "T",
    ("0" + date.getHours()).slice(-2),
    ("0" + date.getMinutes()).slice(-2),
    "00",
  ].join("");
};

export function getFullWeek(dateInput: any) {
  const date = new Date(dateInput.getFullYear(), dateInput.getMonth(), dateInput.getDate());

  const day = date.getDay();

  const diffToMonday = date.getDay() === 0 ? 6 : day - 1;

  const startOfWeek = new Date(date);

  startOfWeek.setDate(date.getDate() - diffToMonday);

  const week = [startOfWeek];
  const epoch = [{ }];

  for (let i = 1; i < 7; i++) {
    const nextDay = new Date(startOfWeek);

    nextDay.setDate(startOfWeek.getDate() + i);
    week.push(nextDay);
  }

  for (let i = 0; i < week.length; i++) {
    epoch[i] = { disabled: true, value: getUnixTimestamp(week[i]).toString(),
      label: week[i].getDate() < 10 ? `0${week[i].getDate()}` : week[i].getDate().toString(),
      day: format(week[i], "EEE"), year: week[i].getFullYear(),
      month: format(week[i], "MMMM"), isNearestAvailableDay: false };
  }
  const data = { epoch, week };

  return data;
}


export function timeAgo(dateParam: Date | string): string {
  const date = typeof dateParam === "object" ? dateParam : new Date(dateParam);
  const now = new Date();
  // Clamp at 0 so a few seconds of clock skew (e.g. a freshly created card with
  // a future timestamp) never renders as "-5 seconds ago".
  const secondsPast = Math.max(0, (now.getTime() - date.getTime()) / 1000);

  if (secondsPast < 60) {
    const seconds = Math.floor(secondsPast);

    return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
  }
  if (secondsPast < 3600) {
    const minutes = Math.floor(secondsPast / 60);

    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  }
  if (secondsPast <= 86400) {
    const hours = Math.floor(secondsPast / 3600);

    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  }
  if (secondsPast > 86400) {
    const day = Math.floor(secondsPast / 86400);

    return `${day} day${day > 1 ? "s" : ""} ago`;
  }

  return "";
}

export function createDate(day: number, month: number, year: number): Date {
  const date = new Date(year, month - 1, day);

  date.setHours(0, 0, 0, 0);

  return date;
}

/*
Input: example: 15-09-1999
Output: Boolean i.e true if the dateYear is valid
*/

export function isValidDate(dateString: string) {
  // Regular expression to match MM/DD/YYYY with exactly 4 digits in the year
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;

  // Checking if the date string matches the pattern
  if (!regex.test(dateString)) return false;
  const [month, day, year] = dateString.split("/").map(Number);
  // range for the Years that can be selected

  if (year < 1900 || year > new Date().getFullYear()) return false;
  const date = new Date(year, month - 1, day);

  // Ensure the parsed date matches the input
  return date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day;
}
